import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginForm } from '../../components';
import LoginForgot from './LoginForgot';
import LoginReset from './LoginReset';
import LoginConfirmEmail from './LoginConfirmEmail';

import back1 from '../../assets/images/back_login1.webp';
import back2 from '../../assets/images/back_login2.webp';
import back3 from '../../assets/images/back_login3.webp';
import back4 from '../../assets/images/back_login4.webp';
import back5 from '../../assets/images/back_login5.webp';
import back6 from '../../assets/images/back_login6.webp';

import './Login.css';

const LOGIN_BACKGROUNDS = [back1, back2, back3, back4, back5, back6];
const rand = parseInt(Math.random() * 1000, 10);
const back = LOGIN_BACKGROUNDS[rand % LOGIN_BACKGROUNDS.length];

const Login = () => {
    return (
        <div className="Login text-center">
            <div className="wrapper">
                <div className="background" style={{ backgroundImage: "url(" + back + ")"}} ></div>
                <Routes>
                    <Route path="/login/forgot" element={<LoginForgot />} />
                    <Route path="/login/reset" element={<LoginReset />} />
                    <Route path="/login/confirm-email" element={<LoginConfirmEmail />} />
                    <Route path="*" element={<LoginForm appear />} />
                </Routes>
            </div>
        </div>
    );
}

export default Login;
